// client-lib/tokenUtils.js
import dayjs from 'dayjs';
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export const getAuthToken = () => {
    const accessToken = sessionStorage.getItem("authToken");
    const tokenExpiration = sessionStorage.getItem("tokenExpiration");

    if (!accessToken || !tokenExpiration) {
        console.log("No token or expiration found."); // Debugging log
        return null;
    }

    if (dayjs().isAfter(dayjs(tokenExpiration))) {
        console.log("Token expired."); // Debugging log
        return null;
    }

    console.log("Token valid."); // Debugging log
    return accessToken;
};

export const useAuthRedirect = () => {
    const navigate = useNavigate();
    const accessToken = getAuthToken();

    useEffect(() => {
        if (!accessToken) {
            console.log("Token missing or expired, redirecting to /login.");
            navigate("/login", { replace: true }); // Use replace to prevent back navigation to the protected route
        }
    }, [accessToken, navigate]);

    return accessToken;
};

export const handleLogout = () => {
    sessionStorage.removeItem('authToken'); // if stored in sessionStorage
    sessionStorage.removeItem('tokenExpiration'); // if stored in sessionStorage

    window.history.pushState(null, "", window.location.href); // Reset the history

    // Redirect to home page
    window.location.href = '/';
};